import React from 'react'
import usMap from '../utils/us-map-data'
import {dispatch} from 'fluxury'
import {changeSelectedState} from '../actions/actions'
import HardestHitStore from '../stores/hardest-hit-store'
import cond from 'formula-cond'

const currentStateFill = '#003087'
const noProgramFill = '#E9E9E9'
const activeProgramFill = '#707070'
const inactiveProgramFill = '#CCCCCC'


var Map = React.createClass({

  handleSelectChange: function(event) {
    dispatch(changeSelectedState, event.target.value)
  },

  handleStateClick: function(e) {
    var stateCode = e.target.getAttribute("data-state");
    dispatch(changeSelectedState, stateCode)
  },

  renderPath: function(stateKey, path, isSelected, count) {
    var hasProgram = HardestHitStore.hasProgram(stateKey),
      hasActiveProgram = HardestHitStore.hasActiveProgram(stateKey);
    return (
      <path key={stateKey + '-'  + count}
        data-state={stateKey}
        fill= {
          cond(
            isSelected,
            currentStateFill,
            hasProgram && hasActiveProgram,
            activeProgramFill,
            hasProgram,
            inactiveProgramFill,
            noProgramFill
          )}
          stroke="#FFF"
          d={path}
          strokeOpacity="1"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          strokeWidth="0.75"
          strokeDasharray="0"
          onClick={cond(hasProgram, this.handleStateClick)}
          style={{
            'strokeOpacity': 1,
            'strokeLinejoin': 'round',
            'strokeMiterlimit': 4,
            'strokeWidth': '0.75px',
            cursor: cond(hasProgram, 'pointer')
          }
        }>
      </path>
    );
  },

  renderMap: function() {
    var paths = []
    Object.keys(usMap).forEach((stateKey) => {
      var pathData = usMap[stateKey],
      isSelected=stateKey===this.props.currentState

      if (stateKey === 'DC') {
      }

      paths.push(this.renderPath(stateKey, pathData, isSelected, 0))

    })

    return paths;

  },

  render:function(){
    return(
      <div className="map-container">
        <div className="h4 mb-4 map-header">
          Select Your State to View Available Programs
        </div>
        <div className="form-group" id="select-state">
          <select className="form-control custom-select mb-4"
            onChange={this.handleSelectChange}
            value={this.props.currentState !== '' ? this.props.currentState : 'Select Your State'}
            title="Select Your State">
            <option value="">Select Your State</option>
            {this.props.statesList.map(function(selectState) {
              return (
                <option key={selectState.key} value={selectState.key}>{selectState.name}</option>
              )
            })}
          </select>
        </div>

        <svg viewBox="0 0 950 700" xmlns="http://www.w3.org/2000/svg" version="1.1">
          {this.renderMap()}
        </svg>


      </div>
    )
  }
})

module.exports = Map;



// WEBPACK FOOTER //
// ./src/components/map.js